import getVuetify, { mergeConfig, defaultConfig } from '../plugins/vuetify'

const idoniaDomains = ['idonia.com', 'www.idonia.com', 'my.idonia.com', 'demo.idonia.com', 'staging.idonia.com', 'dev.idonia.com']

const hash = '?_=' + Date.now()
let wlURL = 'https://whitelabel.idonia.com/'
const rs = {
  headerLogo: 'theme/header-logo.png',
  vuetify: getVuetify(defaultConfig),
  whitelabelURL: wlURL,
  serverConfig: {}
}
const getWLURL = window.axios.get('ui-config').then(config => {
  wlURL = config.data ? (config.data.publicWhitelabelUrl || wlURL) : wlURL
  if (!wlURL.endsWith('/')) wlURL += '/'
  rs.whitelabelURL = wlURL
}).catch(e => {
  window.console.error(e)
})

export default async function loadWhitelabel (wlDomain) {
  if (wlDomain === '') {
    return rs
  }

  await getWLURL

  // FAVICON..........................
  const faviconUrl = wlURL + wlDomain + '/asset/favicon'
  var oldLink = document.getElementById('favicon-logo')
  const faviconImage = new Image()
  faviconImage.onload = () => {
    var link = document.createElement('link')
    link.id = 'favicon-custom'
    link.rel = 'icon'
    link.href = faviconUrl
    document.head.removeChild(oldLink)
    document.head.appendChild(link)
  }
  faviconImage.src = faviconUrl

  // THEME JSON............................
  const promises = []
  promises.push(window.axios.get(wlURL + wlDomain + '/theme.json' + hash).then(response => {
    let vuetifyTheme = mergeConfig(response.data)
    rs.vuetify = getVuetify(vuetifyTheme)
    if (!idoniaDomains.includes(wlDomain)) {
      rs.headerLogo = wlURL + wlDomain + '/asset/header-logo.png'
    }
  }).catch(e => {
    window.console.error(e)
  })
  )
  // SERVER CONFIG............................
  promises.push(window.axios.get(wlURL + wlDomain + '/config.json' + hash).then(response => {
    rs.serverConfig = response.data
  }).catch(e => {
    window.console.error(e)
  }))

  return Promise.all(promises).then(() => {
    return rs
  })
}

export function buildWLParam (wlDomain, prefix = '&') {
  if (wlDomain === '') {
    return ''
  } else {
    return prefix + 'wl=' + encodeURIComponent(wlDomain)
  }
}
